document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-gst-toggle]');
  if (!toggle) return;

  const wrapper = toggle.closest('[data-gst-price-wrapper]');
  if (!wrapper) return;

  const currentMode = wrapper.getAttribute('data-tax-mode') || 'inc';
  const nextMode = currentMode === 'inc' ? 'ex' : 'inc';

  wrapper.setAttribute('data-tax-mode', nextMode);
  toggle.setAttribute('aria-pressed', nextMode === 'inc' ? 'true' : 'false');

  const showCompare = wrapper.getAttribute(`data-show-compare-${nextMode}`) === 'true';
  const priceClass = wrapper.getAttribute(`data-price-class-${nextMode}`) || 'price-normal';
  const priceValue = wrapper.getAttribute(`data-price-${nextMode}`) || '';
  const compareValue = wrapper.getAttribute(`data-compare-${nextMode}`) || '';
  const savingsValue = wrapper.getAttribute(`data-savings-${nextMode}`) || '';

  const priceRow = wrapper.querySelector('[data-gst-price-row]');
  const compareEl = wrapper.querySelector('[data-gst-compare-price]');
  const mainPriceEl = wrapper.querySelector('[data-gst-main-price]');
  const savingsEl = wrapper.querySelector('[data-gst-savings]');
  const unitPriceWrapper = wrapper.querySelector('[data-gst-unit-price-wrapper]');
  const unitPriceText = unitPriceWrapper ? unitPriceWrapper.querySelector('.unit-price__price, .unit-price') : null;

  if (mainPriceEl) {
    mainPriceEl.textContent = priceValue;
    mainPriceEl.classList.remove('price-normal', 'price-discount');
    mainPriceEl.classList.add(priceClass);
  }

  if (compareEl) {
    compareEl.textContent = compareValue;

    if (showCompare) {
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
  }

  if (savingsEl) {
    savingsEl.textContent = `Save ${savingsValue}`;

    if (showCompare) {
      savingsEl.hidden = false;
    } else {
      savingsEl.hidden = true;
    }
  }

  if (priceRow) {
    if (showCompare) {
      priceRow.classList.remove('price-row--single');
    } else {
      priceRow.classList.add('price-row--single');
    }
  }

  if (unitPriceWrapper && unitPriceText) {
    const unitPriceValue = unitPriceWrapper.getAttribute(`data-unit-price-${nextMode}`);
    if (unitPriceValue) {
      const priceNode = unitPriceWrapper.querySelector('.unit-price__price');
      if (priceNode) {
        priceNode.textContent = unitPriceValue;
      }
    }
  }
});